export default __webpack_public_path__ + "static/media/hostbuddyLogo.c9bdafa1.png";